<template>
	<div>
		<NP-Modal
			class="accept-cash-modal"
			:label="type === 'accept_cash' ? 'Службове внесення' : 'Службова видача'"
			:toggle="toggle"
		>
			<form @submit.prevent="apply">
				<div v-if="type === 'accept_cash'">
					<table v-if="showTable">
						<tr
							v-for="(o, index) in pendingOrders"
							:key="o.id"
							@click="() => onRowClick(index)"
							:class="{ 'radio-active': `radio-${index}` === radioRow }"
						>
							<td>
								<NP-Radio :name="`radio-${index}`" v-model="radioRow" />
							</td>
							<td class="amount">
								<span class="bold gray-50"><span class="uah" />{{ o.recorded_amount | formatMoney }}</span>
							</td>
							<td class="date">
								<span>{{ formatDate(o.created_at) }}</span>
								<i class="icon-calendar" />
							</td>
						</tr>
					</table>
				</div>
				<NP-Input
					v-else-if="type === 'give_cash'"
					name="amount"
					type="monetary"
					v-model="amount"
					:placeholder="'0.00'"
					:error="fieldErrors.amount"
					:min="0"
					:max="availableBalance"
					:disabled="inputDisabled"
				/>

				<div v-if="pendingCourierOrdersList" class="pending-orders-alert">
					<span class="info-icon" />
					<div class="pending-orders-text">
						<span class="bold">Додатково не забудь здати розмінну монету за:</span>
						<span class="list" :key="order.id" v-for="(order, i) in pendingCourierOrdersList">
							{{ `${++i}. ` + order.text }}
						</span>
					</div>
				</div>
				<div class="buttons">
					<NP-Button type="button" priority="low-borderless" class="cancel-btn" @click="toggle">
						<div slot="icon" class="icon-close dark" />
						Скасувати
					</NP-Button>
					<NP-Button
						type="submit"
						priority="high"
						class="confirm-btn"
						:disabled="isApplyButtonDisabled"
						:loading="loading"
					>
						<span v-if="type === 'give_cash'"> Створити </span>
						<span v-else> Прийняти службове внесення </span>
					</NP-Button>
				</div>
			</form>
		</NP-Modal>
	</div>
</template>

<script>
import { DateTime } from 'luxon';
import BigNumber from 'bignumber.js';

import { validation, formatters } from 'novapay-ui';

export default {
	name: 'GiveAcceptCashModal',
	props: {
		state: { type: Object, default: null },
		root: { type: Object, default: null },
		cashdesk: { type: Object, default: null },
		toggle: { type: Function, default: null },
		confirmCashToCashdesk: { type: Function, default: null },
		createCashToCashdesk: { type: Function, default: null },
		createCashFromCashdesk: { type: Function, default: null },
		pendingOrders: { type: Array, default: () => [] },
		pendingCourierOrders: { type: Array, default: () => [] },
		loadingActions: { type: Array, default: () => [] },
		validationErrors: { type: Array, default: null },
		defaultTab: {
			type: String,
			validator: (v) => ['give_cash', 'accept_cash'].includes(v),
			default: 'accept_cash'
		},
		cashdeskClosal: { type: Boolean, default: false }
	},
	data() {
		return {
			amount: null,
			type: this.cashdeskClosal ? 'give_cash' : this.defaultTab,
			radioRow: `radio-0`,
			fieldErrors: null,
			localErrors: []
		};
	},
	computed: {
		isApplyButtonDisabled() {
			if (this.type === 'give_cash') {
				return this.amount <= 0;
			}
			if (this.type === 'accept_cash') {
				let index = this.radioRow.replace('radio-', '');
				let order = this.pendingOrders[index];
				if (!order) {
					return true;
				}
				return !this.pendingOrders?.length;
			}
			return false;
		},
		showTable() {
			return this.pendingOrders && this.pendingOrders.length;
		},
		user() {
			return this.root.user;
		},
		loading() {
			return (
				this.loadingActions.includes('confirmCashToCashdesk') || this.loadingActions.includes('createCashFromCashdesk')
			);
		},
		availableBalance() {
			let { in_balance, out_balance } = this.cashdesk;
			return new BigNumber(in_balance).minus(out_balance).toNumber();
		},
		inputDisabled() {
			return this.cashdeskClosal || !this.availableBalance;
		},
		pendingCourierOrdersList() {
			return (
				this.pendingCourierOrders?.length &&
				this.pendingCourierOrders.map((row) => {
					let amount = formatters.formatMoney(row.factual_amount);
					return {
						id: row.id,
						amount: amount.replace(/\s/g, ''),
						text: `ВКО №${row.id} від ${row.participant_name}; ${amount}грн`,
						cash: row.cash
					};
				})
			);
		}
	},
	methods: {
		onRowClick(index) {
			this.radioRow = `radio-${index}`;
		},
		formatDate(date) {
			return DateTime.fromISO(date).toFormat('HH:mm, dd/MM/yyyy');
		},
		getfieldErrors() {
			this.fieldErrors = validation.computeValidationMessages((this.validationErrors || []).concat(this.localErrors), [
				'amount'
			]);
		},
		setType(type) {
			if (this.type !== type) {
				this.type = type;
				this.fieldErrors = [];
			}
		},
		apply() {
			let validate = validation.compile({
				properties: {
					amount: {
						type: 'number',
						minimum: 0.1,
						multipleOf: 0.1,
						maximum: 99999999.99
					}
				}
			});

			if (this.type === 'accept_cash') {
				let index = this.radioRow.replace('radio-', '');
				let order = this.pendingOrders[index];
				return this.confirmCashToCashdesk({
					order,
					user_id: this.user.id,

					loadingAction: true
				});
			}
			if (this.type === 'give_cash') {
				let { errors } = validate({ amount: this.amount });
				if (errors) {
					this.localErrors = errors;
					return this.getfieldErrors();
				}
				return this.createCashFromCashdesk({
					user_id: this.cashdesk.user_id,
					amount: this.amount,

					loadingAction: true
				});
			}
		}
	},
	beforeMount() {
		this.getfieldErrors();
		this.amount = this.availableBalance;
	},
	watch: {
		validationErrors() {
			this.getfieldErrors();
		}
	}
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/variables';
@import '@assets/scss/mixins';
$icon-close: '~@assets/images/icon-close.svg';
$icon-calendar-filled: '~@assets/images/icon-calendar-filled.svg';
$icon-info-donate: '~@assets/images/icon-info-donate.svg';

.accept-cash-modal {
	& ::v-deep .modal-container {
		width: 450px;
		max-height: 80vh;
		overflow-y: auto;
		table {
			width: 100%;
			.uah {
				color: $gray-40;
				margin-right: 4px;
			}
			.icon-calendar {
				@include make-icon($icon-calendar-filled, $gray-30, 24px, 20px);
			}
			tr {
				flex: 1;
				display: flex;
				height: 40px;
				padding: 0 12px;
				margin-bottom: 8px;
				align-items: center;
				background-color: #eeeff2;
				border-radius: $border-radius;
				cursor: pointer;
				&.radio-active {
					background: $pink;
				}
				td {
					display: flex;
					flex: 1;
					align-items: center;
				}
				td:first-child {
					max-width: 40px;
				}
				.amount span,
				.date span {
					margin-top: 2px;
				}
				.date {
					flex: 2;
					flex-direction: row-reverse;
				}
			}
			tr:last-child {
				margin-bottom: 0;
			}
		}
		.cancel-btn {
			color: $gray-40;
		}
		.buttons-type {
			display: flex;
			margin-bottom: 16px;
			.button {
				flex: 1;
				&:first-child {
					border-top-right-radius: 0;
					border-bottom-right-radius: 0;
				}
				&:nth-child(2) {
					border-top-left-radius: 0;
					border-bottom-left-radius: 0;
				}
			}
		}
		.buttons {
			display: flex;
			justify-content: space-between;
			margin-top: 24px;
			.icon-close {
				@include make-icon($icon-close, $gray-40, 20px, 20px);
			}
		}
	}
	.pending-orders {
		&-text {
			display: flex;
			flex-direction: column;
			align-items: flex-start;
			gap: 5px;
			.bold {
				font-weight: 600;
			}
			.list {
				margin-left: 5px;
			}
		}
		&-alert {
			display: flex;
			justify-content: center;
			align-items: center;
			gap: 12px;
			background-color: $lilac-200;
			padding: 10px 12px;
			border-radius: 4px;
			margin-top: 24px;
			.info-icon {
				min-width: 20px;
				@include make-icon($icon-info-donate, $gray-50, 20px, 20px);
			}
		}
	}
	@include mobile {
		.buttons {
			flex-direction: column;
			.cancel-btn {
				margin-bottom: 16px;
			}
		}
	}
}
</style>
